export default __webpack_public_path__ + "static/media/replace.debf47dd.png";